import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { canAccess, getDefaultRoute } from 'utils/roleAccess';
import type { AppSection } from 'utils/roleAccess';

interface Props {
  sectionKey: string;
  children: React.ReactNode;
}

const DataManagementRouteGuard: React.FC<Props> = ({ sectionKey, children }) => {
  const { auth } = useAuth();

  // Wait until user profile is fully loaded before checking access.
  // On reload, accountProfile is undefined until the profile API call completes.
  // Without this, the guard redirects away before roles are available.
  if (auth.isLoading || !auth.user || !auth.user.accountProfile) {
    return null;
  }

  if (!canAccess(auth.user, sectionKey as AppSection)) {
    return <Navigate to={getDefaultRoute(auth.user)} replace />;
  }

  return <>{children}</>;
};

export default DataManagementRouteGuard;
